module.exports = __webpack_public_path__ + "img/ruler.3796012a.svg";